// extracted by mini-css-extract-plugin
module.exports = {"container":"Notifications_container_27WtM","header":"Notifications_header_1U86g"};